import { useNavigate } from 'react-router-dom';
import { getDateFirstYear4 } from '../utils/getDate.js';
import { GreenButton, NoBgButton } from './buttons.js';
import { useState } from 'react';
import Loader from './Loader.jsx';

const AdminCard = ({ elementData, type }) => {
    const navigate = useNavigate();
    // Vai a pagina edit
    const goToEdit = (id) => {
        if (type === 'Activity') {
            navigate(`/add-edit-activity?activityId=${id}`)
        }
        if (type === 'Product') {
            navigate(`/add-edit-product?productId=${id}`)
        }
        if (type === 'Company') {
            navigate(`/add-edit-company?companyId=${id}`)
        }
    }

    // Vai a pagina dettagli (vista utente)
    const goToDetails = (id) => {
        if (type === 'Activity') {
            navigate(`/activity-details?id=${id}`)
        }
        if (type === 'Product') {
            navigate(`/product-details?productId=${id}`)
        }
        if (type === 'Company') {
            navigate(`/company-details?companyId=${id}`)
        }
    }

    // handle isDeleting
    const [isDeleting, setIsDeleting] = useState(false);
    const [deleteFetchStatus, setDeleteFetchStatus] = useState('idle');
    const [, setDeleteError] = useState(null);
    // send delete fetch
    const sendDelete = async () => {
        setDeleteFetchStatus('loading');
        const token = localStorage.getItem('ticino-wild-token');
        let url;
        let body;
        let imagesIdArray = [];
        if (elementData.gallery) {
            elementData.gallery.forEach(element => {
                imagesIdArray.push(element.public_id)
            });
        }
        if (type === 'Activity') {
            url = `${process.env.REACT_APP_SERVER_BASE_URL}/activities/delete-activity`;
            body = { activityId: elementData._id, imagesIdArray: imagesIdArray };
        }
        if (type === 'Product') {
            url = `${process.env.REACT_APP_SERVER_BASE_URL}/products/delete-product`;
            body = { productId: elementData._id, imagesIdArray: imagesIdArray };
        }
        if (type === 'Company') {
            url = `${process.env.REACT_APP_SERVER_BASE_URL}/companies/delete-company`;
            body = { companyId: elementData._id }
        }
        const headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        };
        const options = {
            method: 'DELETE',
            headers,
            body: JSON.stringify(body)
        }
        try {
            const response = await fetch(url, options);
            if (response.ok) {
                setDeleteFetchStatus('succeeded');
                setTimeout(() => {
                    window.location.reload();
                }, 2000)
            } else {
                const error = await response.json();
                setDeleteError(error);
                setDeleteFetchStatus('failed');
            }
        } catch (error) {
            setDeleteError(error);
            console.log('Catch deleteError: ', error);
            setDeleteFetchStatus('failed');
        }
    }

    return (
        <div className={`flex flex-col lg:flex-row gap-2 lg:gap-4 justify-start items-start lg:items-center w-full bg-white lg:bg-transparent hover:bg-white py-2 px-4 rounded-xl text-sm ${isDeleting ? 'border-2 border-red-500' : 'border'}`}>
            {
                (type === "Activity" || type === "Product") &&
                <div className="w-full lg:w-12 lg:h-12">
                    <img src={elementData.coverImageUrl ? elementData.coverImageUrl.resizedUrl : ''} alt={elementData.title || ''} className="flex-1 rounded object-cover w-full h-full" />
                </div>
            }
            {
                type === 'Company' &&
                <div className='flex flex-col md:flex-row gap-2 p-2 mt-4 md:mt-0'>
                    <div><h3 className='md:hidden'>{elementData.companyName}</h3></div>
                    <div className='md:min-w-[240px] max-w-[240px]'><h4 className='hidden md:block'>{elementData.companyName}</h4></div>
                    <div className='w-[170px]'>- IDI: {elementData.IDI}</div>
                </div>
            }
            <div className="w-[240px] flex flex-col">
                <div className='font-bold'>{elementData.title}</div>
                {/* Gratuita */}
                {!elementData.isPremium && !elementData.isExternalPaid && <div className="text-[#225424]">Gratuita</div>}
                {/* A pagamento */}
                {!elementData.isExternalPaid && elementData.isPremium && <div className="text-[#225424]">A pagamento</div>}
                {/* A pagamento esterno */}
                {elementData.isExternalPaid && <div className="text-[#225424]">A pagamento esterno</div>}
            </div>
            <div className={`w-[90px] ${type === 'Product' && 'text-4xl font-bold text-[#225424]'}`}>
                <div>{type === 'Activitity' && elementData.activityType}</div>
                {
                    type === "Product" &&
                    <div className='flex flex-col'>
                        <div>{elementData.price.toFixed(2)}</div>
                        {elementData.shippingCost > 0 && <div className='text-xs text-neutral-500 whitespace-nowrap'>+ {elementData.shippingCost.toFixed(2)} CHF</div>}
                    </div>
                }
            </div>
            <div className="w-[100px]">{getDateFirstYear4(elementData.createdAt)}</div>
            {(type === "Activity" || type === "Product") && <div className="w-[70px]">{elementData.isActive ? 'Pubblicato' : 'Bozza'}</div>}
            {
                !isDeleting && <div className="flex flex-col md:flex-row gap-2 w-full md:w-fit">
                    <button className="rounded-lg border border-neutral-300 text-[#225424] flex justify-center items-center text-xl py-2 px-4 hover:bg-[#e2eeed] gap-2" onClick={() => goToEdit(elementData._id)}><div className='pt-[5px]'><i className="fi fi-rr-edit"></i></div><div className='lg:hidden'>Modifica</div></button>
                    <button className="rounded-lg border border-neutral-300 text-[#225424] flex justify-center items-center text-xl py-2 px-4 hover:bg-[#e2eeed] gap-2" onClick={(() => setIsDeleting(true))}><div className='pt-[5px]'><i className="fi fi-rr-trash"></i></div><div className='lg:hidden'>Elimina</div></button>
                    <button className="rounded-lg border border-neutral-300 text-[#225424] flex justify-center items-center text-xl py-2 px-4 hover:bg-[#e2eeed] gap-2" onClick={() => goToDetails(elementData._id)}><div className='pt-[5px]'><i className="fi fi-rr-eye"></i></div><div className='lg:hidden'>Visualizza</div></button>
                </div>
            }
            {
                isDeleting && deleteFetchStatus === 'idle' &&
                <div className='flex flex-col gap-2 items-start'>
                    <h4>Confermi l'eliminazione?</h4>
                    <div className="flex flex-col xl:flex-row gap-2">
                        <NoBgButton text="Conferma" click={sendDelete} />
                        <GreenButton text="Annulla" click={() => setIsDeleting(false)} />
                    </div>
                </div>
            }
            {
                isDeleting && deleteFetchStatus === 'succeeded' &&
                <h4>{type === 'Activity' && 'Attività rimossa.'}{type === 'Product' && 'Prodotto rimosso.'}{type === 'Company' && 'Azienda rimossa.'} Attendi il refresh della pagina.</h4>
            }
            {
                isDeleting && deleteFetchStatus === 'failed' &&
                <h4>Qualcosa è andato storto. Ricarica la pagina e riprova.</h4>
            }
            {
                isDeleting && deleteFetchStatus === 'loading' &&
                <Loader />
            }
        </div>
    )
}

export default AdminCard;